import { useState } from "react";
import { serialized } from "@/mocks/manga";

const categories = ["全部", "古风奇幻", "美食治愈", "科幻冒险", "志怪灵异", "都市治愈", "悬疑冒险"];

export default function Serialized() {
  const [cat, setCat] = useState("全部");
  const list = cat === "全部" ? serialized : serialized.filter((s) => s.category === cat);

  return (
    <section id="serial" className="bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm font-medium text-secondary-800">
            <i className="ri-loader-4-line"></i>
            人气连载 · 追更进度条
          </p>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
            正在追更的人气连载
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
            每部连载都有实时追更进度条，点开即知最新话进度，长期连载不怕断。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {categories.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setCat(c)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                cat === c
                  ? "bg-primary-500 font-medium text-background-50"
                  : "bg-background-50 text-foreground-700 ring-1 ring-background-300/60 hover:text-primary-700"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((item) => (
            <article
              key={item.title}
              className="group overflow-hidden rounded-xl bg-background-50 ring-1 ring-background-200/70"
            >
              <div className="flex gap-4 p-4">
                <div className="relative h-32 w-24 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={item.cover}
                    alt={`${item.title} 追更进度漫画封面`}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                  <span className="absolute left-1 top-1 rounded-full bg-primary-500 px-2 py-0.5 text-[11px] text-background-50">
                    {item.updateBadge}
                  </span>
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <h3 className="font-medium text-foreground-950">{item.title}</h3>
                  <p className="mt-0.5 text-xs text-foreground-600">{item.author}</p>
                  <span className="mt-2 inline-flex w-fit items-center gap-1 rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                    {item.category}
                  </span>
                  <p className="mt-2 text-xs text-foreground-700">
                    连载至 <span className="font-semibold text-primary-600">{item.chapters}</span> 话
                  </p>
                  <p className="mt-1 text-xs text-foreground-600">
                    下次更新 <span className="font-medium text-accent-700">{item.nextUpdate}</span>
                  </p>
                </div>
              </div>

              <div className="px-4 pb-4">
                <div className="flex items-center justify-between text-xs">
                  <span className="text-foreground-600">追更进度</span>
                  <span className="font-semibold text-primary-600">{item.progress}%</span>
                </div>
                <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                    style={{ width: `${item.progress}%` }}
                  ></div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}